import { render } from "./SearchSamplesSampleItem.vue?vue&type=template&id=ffd76ab6&scoped=true"
import script from "./SearchSamplesSampleItem.vue?vue&type=script&lang=js"
export * from "./SearchSamplesSampleItem.vue?vue&type=script&lang=js"

import "./SearchSamplesSampleItem.vue?vue&type=style&index=0&id=ffd76ab6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd76ab6"]])

export default __exports__